import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/ProductTraining`,
  scopes: ExtHubRequest,
});

let entities = [
  { name: 'GetTrainingCodes' },
  { name: 'GetTrainingModule' },
  { name: 'CheckProductTrainingAccess' },
  { name: 'GetProductTrainingStatus' },
  { name: 'SetProductTraining' },
];

api.createEntities(entities);

const GetTrainingCodes = (training) => api.endpoints.GetTrainingCodes.getWithURI(training);
const GetTrainingModule = (trainingCode) =>
  api.endpoints.GetTrainingModule.getWithURI(trainingCode);
const CheckProductTrainingAccess = (trainingCode) =>
  api.endpoints.CheckProductTrainingAccess.getWithURI(trainingCode);
const GetProductTrainingStatus = (training) =>
  api.endpoints.GetProductTrainingStatus.getWithURI(training);
const SetProductTraining = (body) => api.endpoints.SetProductTraining.post(body);

export {
  GetTrainingCodes,
  GetTrainingModule,
  CheckProductTrainingAccess,
  GetProductTrainingStatus,
  SetProductTraining,
};
